/*global SunergoPlatform,tinymce*/

import _ from 'lodash';

/**
 * Initialize TinyMCE Fields.
 */
const initTinymce = function() {
	const tinymceClass = '[data-tinymce]';
	const hasTinymce = document.querySelectorAll(tinymceClass);
	const totalEditors = hasTinymce.length;
	const forms = SunergoPlatform.forms;

	if (totalEditors < 1) return;

	// TinyMCE takes a while to load, so we'll show the loading bar.
	SunergoPlatform.loading.add('tinymce-init');

	let isLoading = totalEditors;

	const toolbar = {
		strong: 'bold',
		em: 'italic',
		span: 'underline strikethrough',
		blockquote: 'blockquote',
		sub: 'subscript',
		sup: 'superscript',
		ul: 'bullist',
		ol: 'numlist',
		hr: 'hr',
		a: 'link unlink',
		alignLeft: 'alignleft',
		alignCenter: 'aligncenter',
		alignRight: 'alignright'
	};

	const defaultConfig = {
		skin: 'Sunergo',
		content_css: 'Sunergo',
		plugins: 'link lists hr',
		menubar: false,
		width: '100%',
		min_height: 300,
		toolbar:
			`undo redo | ${toolbar.strong} ${toolbar.em} ${toolbar.span} ${toolbar.blockquote} | ${toolbar.sub} ${toolbar.sup} | ${toolbar.alignLeft} ${toolbar.alignCenter} ${toolbar.alignRight} | ${toolbar.hr} | ${toolbar.ul} ${toolbar.ol} | ${toolbar.a} | removeformat`,
		valid_elements:
			'a[href|target=_blank],p[style],strong/b,em/i,br,ul,ol,li,hr,span[!style],sub,sup,blockquote',
		valid_styles: {
			'*': 'text-decoration'
		},
		content_style: `:root {${document.body.style.cssText}}`,
		mobile: {
			toolbar_mode: 'floating'
		},
		setup: function(editor) {
			editor.on('init', function() {
				// Once an editor is loading, subtract from the isLoading count.
				// Then if there aren't any more loading, we can let the document know it's loaded.
				isLoading--;
				const formName = editor.editorContainer.closest('form').name;
				const textareaField = editor.editorContainer.parentElement.querySelector(
					'textarea[data-tinymce]'
				);
				if (isLoading < 1) SunergoPlatform.loading.remove('tinymce-init');

				if (editor.isDirty()) forms[formName].changeLog.add(textareaField);
			});
			editor.on('focusin', function() {
				this.editorContainer.classList.add('tox-focused');
			});
			editor.on('focusout', function() {
				this.editorContainer.classList.remove('tox-focused');
			});
			editor.on('change', function() {
				// Update the form's change log if fieldset is dirty.
				const formName = editor.editorContainer.closest('form').name;
				const textareaField = editor.editorContainer.parentElement.querySelector(
					'textarea[data-tinymce]'
				);
				if (editor.isDirty()) forms[formName].changeLog.add(textareaField);
				else forms[formName].changeLog.remove(textareaField);
			});
		}
	};

	const defaultSelectorId = '__default__';

	for (let i = 0; i < totalEditors; i++) {
		const editor = hasTinymce[i];
		if (editor.dataset.tinymce == `${defaultSelectorId}`) continue;

		const customConfig = JSON.parse(editor.dataset.tinymceCustom);
		const mergedConfig = Object.assign(_.cloneDeep(defaultConfig), customConfig);

		// Remove toolbar items based on valid elements.
		if (mergedConfig.valid_elements) {
			const validElements = mergedConfig.valid_elements.split(',');

			if (!validElements.includes('a[href]') && !validElements.includes('a[href|target=_blank]')) {
				mergedConfig.plugins = mergedConfig.plugins.replace('link', '');
				mergedConfig.toolbar = mergedConfig.toolbar.replace(toolbar.a, '');
			}

			if (!validElements.includes('strong/b'))
				mergedConfig.toolbar = mergedConfig.toolbar.replace(toolbar.strong, '');
			if (!validElements.includes('em/i'))
				mergedConfig.toolbar = mergedConfig.toolbar.replace(toolbar.em, '');
			if (!validElements.includes('span'))
				mergedConfig.toolbar = mergedConfig.toolbar.replace(toolbar.span, '');
			if (!validElements.includes('sub'))
				mergedConfig.toolbar = mergedConfig.toolbar.replace(toolbar.sub, '');
			if (!validElements.includes('sup'))
				mergedConfig.toolbar = mergedConfig.toolbar.replace(toolbar.sup, '');
			if (!validElements.includes('hr'))
				mergedConfig.toolbar = mergedConfig.toolbar.replace(toolbar.hr, '');
			if (!validElements.includes('ul'))
				mergedConfig.toolbar = mergedConfig.toolbar.replace(toolbar.ul, '');
			if (!validElements.includes('ol'))
				mergedConfig.toolbar = mergedConfig.toolbar.replace(toolbar.ol, '');
			if (!validElements.includes('blockquote'))
				mergedConfig.toolbar = mergedConfig.toolbar.replace(toolbar.blockquote, '');

			if (!customConfig.textAlign) {
				mergedConfig.toolbar = mergedConfig.toolbar.replace(`${toolbar.alignLeft} ${toolbar.alignCenter} ${toolbar.alignRight}`, '');
			} else {
				mergedConfig.valid_styles['p'] = 'text-align';
			}
		}

		mergedConfig.selector = `[data-tinymce="${editor.dataset.tinymce}"]`;
		tinymce.init(mergedConfig);
	}

	const defaultSelector = `[data-tinymce="${defaultSelectorId}"]`;
	if (document.querySelectorAll(defaultSelector)) {
		defaultConfig.selector = defaultSelector;
		defaultConfig.toolbar = defaultConfig.toolbar.replace(`${toolbar.alignLeft} ${toolbar.alignCenter} ${toolbar.alignRight}`, '');
		tinymce.init(defaultConfig);
	}
};

export default initTinymce;